
export const MESSENGER_LINK = 'https://m.me/njeanne1';